import { render, staticRenderFns } from "./LumpAFEBudget.vue?vue&type=template&id=67d61974&scoped=true"
import script from "./LumpAFEBudget.vue?vue&type=script&lang=ts"
export * from "./LumpAFEBudget.vue?vue&type=script&lang=ts"
import style0 from "./LumpAFEBudget.vue?vue&type=style&index=0&id=67d61974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d61974",
  null
  
)

export default component.exports